var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"driver"},[_c('dynamic-form-component',{ref:"drivers-form",staticClass:"pa-3",attrs:{"fieldsConfig":_vm.fieldsConfig,"model":_vm.model}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }